import { createSlice } from '@reduxjs/toolkit'

import { historySelectors } from '../selectors/history'

const initialState = {
    exports: [],
    exportsLoading: false,
    exportsError: null,
    audit: [],
    auditLoading: false,
    auditError: null,
    versions: [],
    maxVersions: 6,
    versionsLoading: false,
    versionsError: null,
    versionData: [],
    versionDataLoading: false,
    versionDataError: null,
    generating: false,
    notice: null,
    error: null,
}

const history = createSlice({
    name: 'history',
    initialState,
    reducers: {
        setExports: (state, action) => {
            state.exports = action.payload
        },
        setExportsLoading: (state, action) => {
            state.exportsLoading = action.payload
        },
        setExportsError: (state, action) => {
            state.exportsError = action.payload
        },
        setAudit: (state, action) => {
            state.audit = action.payload
        },
        setAuditLoading: (state, action) => {
            state.auditLoading = action.payload
        },
        setAuditError: (state, action) => {
            state.auditError = action.payload
        },
        setVersions: (state, action) => {
            state.versions = action.payload.versions
            state.maxVersions = action.payload.maxVersions
        },
        setVersionsLoading: (state, action) => {
            state.versionsLoading = action.payload
        },
        setVersionsError: (state, action) => {
            state.versionsError = action.payload
        },
        setVersionData: (state, action) => {
            state.versionData = action.payload
        },
        setVersionDataLoading: (state, action) => {
            state.versionDataLoading = action.payload
        },
        setVersionDataError: (state, action) => {
            state.versionDataError = action.payload
        },
        setGenerating: (state, action) => {
            state.generating = action.payload
        },
        setNotice: (state, action) => {
            state.notice = action.payload
            state.error = null
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        resetNotice: (state) => {
            state.notice = null
        },
    },
    selectors: {
        ...historySelectors,
    },
})

export const historySelector = history.getSelectors()
export const historyActions = history.actions

export default history.reducer
